import { createUSeDirectBookingStrategy } from "./usedirect.js";

export default createUSeDirectBookingStrategy({
  bookingBaseUrl: "https://reservevaparks.com/web",
});
